import { WarningComponent } from '../../shared/components/warning/warning.component';
import { Message } from '../../../app/core/class/message';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { delay, map } from 'rxjs/internal/operators';
import { ErrorCode } from '../constants/error-code';
import { RestApi } from '../models/rest-api.model';
import  * as _ from 'underscore';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiDigitalService {

  /**
   * list of rest-api handling by caller (not by interceptor)
   */
  callerHandlingErrorRestApis: RestApi[] = [];
  BASE_URL = '';

  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    })
  };

  constructor(
    private httpClient: HttpClient,
    public dialog: MatDialog,
    private message: Message,
  ) {
    this.BASE_URL = environment.public_api_endpoint_digital;
  }
  /**
   *  Add Url to get error from api for POST method
   */
  public addUrlToHandlingErrorRestApis(path) {
    this.handleErrorRequest(path, 'POST');
  }

  /**
   *  Add Url to get error from api for PUT method
   */
  public addUrlToHandlingErrorRestApisPut(path) {
    this.handleErrorRequest(path, 'PUT');
  }

  /**
   * Handle error of request
   * @param path path api
   * @param method method request
   */
  public handleErrorRequest(path, method: string) {
    const requestUrl = this.BASE_URL + path;
    const requestRestApi = new RestApi(method, requestUrl);
    this.callerHandlingErrorRestApis.push(requestRestApi);
  }

  /**
   *  Remove Url
   */
  public removeUrlToHandlingErrorRestApis() {
    this.callerHandlingErrorRestApis.pop();
  }

  /**
   *  Get method
   */
  public get(path: string, params: HttpParams = new HttpParams()
  ): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .get(this.BASE_URL + path, { ...this.options, params })
      .pipe(catchError(this.formatErrors));
  }

  /**
   *  fetch data for autocomplete
   **/
  public fetch(path: string, params: HttpParams = new HttpParams()): Promise<any> {
    const query = params.get('filter');
    return this.httpClient.get<any>(this.BASE_URL + path, { ...this.options, params }).pipe(
      map(result => {
        if (query) {
          return result.data;
        }
        return result.data;
      }),
      delay(500))
      .toPromise();
  }

  public getFile(path: string, params: HttpParams = new HttpParams()
  ): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .get(this.BASE_URL + path, { ...this.options, params, responseType: 'blob' })
      .pipe(
        catchError(this.formatErrors)
      );
  }

  public put(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .put(this.BASE_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  /**
   * Make put request and check version
   * @param path: any
   * @param body: any
   * @param callBack: any
   * @param noCallBack: any
   */
  public putAndCheckVersion(path: string, body: object = {}, callBack: any, noCallBack: any, errCallback?: any) {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    const requestUrl = this.BASE_URL + path;
    const requestRestApi = new RestApi('PUT', requestUrl);
    this.callerHandlingErrorRestApis.push(requestRestApi);
    this.httpClient
      .post(requestUrl, JSON.stringify(body), this.options)
      .subscribe((rs: any) => {
        // check if response has error or not
        if (errCallback && !rs.success) {
          errCallback(rs);
        } else {
          const response: any = rs;
          if (response && response.code === ErrorCode.VersionDuplicate) {
            const dialogRef = this.dialog.open(WarningComponent, {
              width: '350px',
              data: this.message.getMessage(response.message)
            });
            dialogRef.afterClosed().subscribe(rss => {
              if (rss) {
                const newBody: any = body;
                newBody.skipVersion = true;
                this.httpClient
                  .put(this.BASE_URL + path, JSON.stringify(newBody), this.options)
                  .pipe()
                  .subscribe(rsss => {
                    callBack();
                  });
              } else {
                noCallBack();
              }
            });
          } else if (response && response.code === ErrorCode.TaxCodeDuplicate) {
            noCallBack(response.code);
          } else {
            callBack();
          }
        }
      },
        err => {
          // console.log('Error in putAndCheckVersion', err);
          this.callerHandlingErrorRestApis = _.reject(this.callerHandlingErrorRestApis, (el: RestApi) => {
            return el.method === requestRestApi.method && el.url === requestRestApi.url;
          });
        }
        , () => this.callerHandlingErrorRestApis = _.reject(this.callerHandlingErrorRestApis, (el: RestApi) => {
          return el.method === requestRestApi.method && el.url === requestRestApi.url;
        }));
  }

  public post(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .post(this.BASE_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  public postFormData(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    const formData = new FormData();
    for (let [key, value] of Object.entries(body)) {
      formData.append(key, value);
    }
    return this.httpClient
      .post(this.BASE_URL + path, formData, this.options)
      .pipe(catchError(this.formatErrors));
  }

  public postUpload(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      // 'Content-Type': 'application/json',
      // 'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .post(this.BASE_URL + path, body, this.options)
      .pipe(catchError(this.formatErrors));
  }

  public delete(path: string): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient.delete(this.BASE_URL + path, this.options)
      .pipe(catchError(this.formatErrors));
  }

  public formatErrors(error: any): Observable<any> {
    return throwError(error.error);
  }

  /**
   * Get base url of web api.
   */
  public getBaseUrl() {
    return this.BASE_URL;
  }

  public shoudIngoreHanldingError(restApi: RestApi): boolean {
    return _.findWhere(this.callerHandlingErrorRestApis, restApi);
  }

}
